import {
  extractLastNameComponent,
  pathToModuleStyle,
} from '@spotify/confidence-core-react';
import { AttachmentFragment } from '@spotify/confidence-graphql';

import { getArtifactDisplayName } from '../artifactUtils';
import {
  resolveArtifactIcon,
  useArtifactExtensions,
} from '../extensions/artifact-extension';

export const useArtifactDisplay = (
  artifact: AttachmentFragment,
  resolvedDisplayName?: string,
) => {
  const extensions = useArtifactExtensions();
  const ext = extensions.find(e => e.predicate(artifact));
  const { Icon } = resolveArtifactIcon(ext, artifact);
  const typeLabel =
    pathToModuleStyle(artifact.uri)?.label ?? ext?.label ?? 'Link';
  const fallbackName = extractLastNameComponent(artifact.uri);
  const displayName = getArtifactDisplayName(
    artifact,
    resolvedDisplayName || fallbackName,
  );

  return { Icon, typeLabel, displayName, ext };
};
